import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
export function BoardAdvisory() {
  const positions = [{
    role: 'Board of Directors',
    org: 'CyberShield Technologies',
    tenure: '2022 — Present'
  }, {
    role: 'Technical Advisory Board',
    org: 'Quantum Computing Institute',
    tenure: '2021 — Present'
  }, {
    role: 'Senior Advisor',
    org: 'National Cybersecurity Council',
    tenure: '2020 — Present'
  }, {
    role: 'Board Observer',
    org: 'Three AI/ML Startups',
    tenure: 'Various'
  }];
  return <section id="board-advisory" className="py-20 bg-dark-bg" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-76">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-77">
          <motion.div variants={fadeInUp} className="mb-12" data-id="element-78">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-79">
              Governance
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-80">
              Board & Advisory
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-81">
            {positions.map((pos, i) => <motion.div key={i} variants={fadeInUp} className="bg-dark-card border border-dark-border border-t-2 border-t-gold p-6 rounded-lg hover:shadow-[0_4px_20px_rgba(212,168,67,0.08)] transition-shadow" data-id="element-82">
                <div className="text-white font-bold text-lg mb-2" data-id="element-83">
                  {pos.role}
                </div>
                <div className="text-gold/80 mb-4" data-id="element-84">{pos.org}</div>
                <div className="text-slate-500 font-sans text-xs uppercase tracking-wider" data-id="element-85">
                  {pos.tenure}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}